export class DslConnectorConstants {
  public static readonly columnLevel = 'columnLevel';
  public static readonly columnDelimiter = 'columnDelimiter';
  public static readonly columnNamesAsHeader = 'columnNamesAsHeader';
  public static readonly compressionLevel = 'compressionLevel';
  public static readonly compressionCodec = 'compressionCodec';
  public static readonly container = 'container';
  public static readonly database = 'database';
  public static readonly databaseType = 'databaseType';
  public static readonly encoding = 'encoding';
  public static readonly encodingName = 'encodingName';
  public static readonly entity = 'entity';
  public static readonly escapeChar = 'escapeChar';
  public static readonly fileName = 'fileName';
  public static readonly fileMode = 'fileMode';
  public static readonly fileSystem = 'fileSystem';
  public static readonly folderPath = 'folderPath';
  public static readonly format = 'format';
  public static readonly local = 'local';
  public static readonly manifestName = 'manifestName';
  public static readonly manifestType = 'manifestType';
  public static readonly nullValue = 'nullValue';
  public static readonly quoteChar = 'quoteChar';
  public static readonly store = 'store';
  public static readonly tableName = 'tableName';
  public static readonly rowDelimiter = 'rowDelimiter';
  public static readonly wildcardPaths = 'wildcardPaths';
  public static readonly datasetReference = 'DatasetReference';
  public static readonly schemaName = 'schemaName';
  public static readonly keys = 'keys';
  public static readonly deletable = 'deletable';
  public static readonly insertable = 'insertable';
  public static readonly updateable = 'updateable';
  public static readonly upsertable = 'upsertable';
  public static readonly defaultToUpsert = 'defaultToUpsert';
  public static readonly dateFormats = 'dateFormats';
  public static readonly allowSchemaDrift = 'allowSchemaDrift';
  public static readonly timestampFormats = 'timestampFormats';
  public static readonly inferDriftedColumnTypes = 'inferDriftedColumnTypes';
  public static readonly eventHubsName = 'eventHubName';
  public static readonly payloadSchema = 'payloadSchema';
  public static readonly eventHubsNamePattern = 'eventHubNamePattern';
  public static readonly enableCdc = 'enableCdc';
  public static readonly passThrough = 'passthrough';
  public static readonly skipInitialLoad = 'skipInitialLoad';
  public static readonly documentForm = 'documentForm';
  public static readonly unquotedColumnNames = 'unquotedColumnNames';
  public static readonly hasComments = 'hasComments';
  public static readonly singleQuoted = 'singleQuoted';
  public static readonly backslashEscape = 'backslashEscape';
  public static readonly includeHeaders = 'includeHeaders';
  public static readonly schemaInferenceType = 'schemaInferenceType';
  public static readonly numSampleRecords = 'numSampleRecords';
  public static readonly autoInferSchema = 'autoInferSchema';
  public static readonly bootstrapServers = 'bootstrapServers';
  public static readonly subscribe = 'subscribe';
  public static readonly subscribePattern = 'subscribePattern';
  public static readonly keyspace = 'keyspace';
  public static readonly seekToTimestamp = 'seekToTimestamp';
  public static readonly waterMarkColumn = 'waterMarkColumn';


  public static readonly dateFormatOptions: string[] = [
    'MM/dd/yyyy',
    'dd/MM/yyyy',
    'yyyy/MM/dd',
    'MM-dd-yyyy',
    'dd-MM-yyyy',
    'yyyy-MM-dd',
    'dd.MM.yyyy',
    'MM.dd.yyyy',
    'yyyy.MM.dd'];

  public static readonly timestampFormatOptions: string[] = [
    'yyyyMMddHHmm',
    'yyyyMMdd HHmm',
    'yyyyMMddHHmmss',
    'yyyyMMdd HHmmss',
    'dd-MM-yyyy HH:mm:ss',
    'dd-MM-yyyy HH:mm',
    'yyyy-M-d H:m:s',
    'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'',
    'yyyy-M-d\'T\'H:m:s\'Z\'',
    'yyyy-M-d\'T\'H:m:s',
    'yyyy-MM-dd\'T\'HH:mm:ss',
    'yyyy-MM-dd HH:mm:ss',
    'yyyy-MM-dd HH:mm',
    'yyyy.MM.dd HH:mm:ss',
    'MM/dd/yyyy HH:mm:ss',
    'M/d/yyyy H:m:s',
    'yyyy/MM/dd HH:mm:ss',
    'yyyy/M/d H:m:s',
    'dd MMM yyyy HH:mm:ss',
    'dd MMMM yyyy HH:mm:ss',
    'd MMM yyyy H:m:s',
    'd MMMM yyyy H:m:s',
    'd-M-yyyy H:m:s',
    'd-M-yyyy H:m',
    'yyyy-M-d H:m',
    'MM/dd/yyyy HH:mm',
    'M/d/yyyy H:m',
    'yyyy/MM/dd HH:mm',
    'yyyy/M/d H:m',
    'dd MMMM yyyy HH:mm',
    'dd MMM yyyy HH:mm',
    'd MMMM yyyy H:m',
    'd MMM yyyy H:m',
    'MM-dd-yyyy hh:mm:ss a',
    'MM-dd-yyyy HH:mm:ss',
    'MM/dd/yyyy hh:mm:ss a',
    'yyyy.MM.dd hh:mm:ss a',
    'MM/dd/yyyy',
    'dd/MM/yyyy',
    'yyyy/MM/dd',
    'MM-dd-yyyy',
    'dd-MM-yyyy',
    'yyyy-MM-dd',
    'dd.MM.yyyy',
    'MM.dd.yyyy',
    'yyyy.MM.dd'];
}
